import React, { useRef, useEffect, useState } from "react";
import Star from "../Star/Star";
import propTypes from "prop-types";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ToTitleCase } from "_shared/helpers";
import { hasSpecialChars } from "./Resource.helpers";

const ResourcesSubNav = ({
  setHoverResources,
  currentTabResources,
  isMobile,
  setFadeClass,
  fadeClass,
  subNavRef,
  handleMouseLeave,
  handleMouseEnter,
}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();

  const handleAnimationEnd = (e) => {
    if (e.animationName.includes("fade-out")) {
      setHoverResources(false);
    }
  };

  const handleTabClick = (url) => navigate(url);
  const getNavLinkClass = (url) => currentPath.includes(url);

  const getTitleName = (name) => {
    if (name === "Corporate IT" || name === "AppliedKids") return name;
    return ToTitleCase(name);
  };

  const Tabs = () =>
    currentTabResources?.map((tab, index) => {
      const urlName = tab.name.replace(/\s+/gi, "-");
      const specialChar = hasSpecialChars(urlName);
      const url = `/resources/${
        specialChar ? encodeURIComponent(urlName) : urlName
      }`;
      // const TitleCaseName = getTitleName(tab.name);
      return (
        <li
          ref={subNavRef}
          key={index}
          className={`${
            getNavLinkClass(url)
              ? "font-semibold md:border-b-0 md:border-r-0 md:border-t-0 md:border-solid md:border-l-secondary md:bg-base-15 [&>a]:text-primary"
              : ""
          } group flex list-none justify-between border-l-0 pl-[15px] hover:bg-base-15 2lg:hover:visible [&_div]:cursor-pointer [&_div]:hover:cursor-pointer [&_i]:hover:cursor-pointer`}
        >
          <NavLink
            className="tab-name text-[#373D43] no-underline"
            onClick={() => {
              handleTabClick(url);
              setHoverResources(false);
            }}
            data-cy={`subnav-link`}
            to={url}
          >
            {tab.name}
          </NavLink>
        </li>
      );
    });

  if (!currentTabResources?.length) return null;

  return !isMobile ? (
    <div
      className={`
        relative mx-auto h-[calc(100vh-4px)] bg-white shadow-[0px_4px_8px_rgba(0,0,0,0.2)]
        md:my-0 md:ml-0 md:mr-[15px] md:inline-block md:border-base-30
        ${fadeClass === "fade-in" ? "animate-fade-in" : ""}
        ${
          fadeClass === "fade-out" ? "pointer-events-none animate-fade-out" : ""
        }
        will-change-[opacity,transform]
      `}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onAnimationEnd={handleAnimationEnd}
    >
      <div
        className="h-full overflow-hidden overflow-x-hidden 
        overflow-y-scroll 
        [&::-webkit-scrollbar-thumb]:rounded-full 
        [&::-webkit-scrollbar-thumb]:bg-[#c3c3c3]        
        hover:[&::-webkit-scrollbar-thumb]:bg-[#686868]
        [&::-webkit-scrollbar-track]:bg-transparent 
        [&::-webkit-scrollbar]:w-[4px]"
      >
        <ul className="mt-0 h-[39px] w-[235px] pl-0 [&_li:last-child]:border-b-0 [&_li]:border-b [&_li]:border-r-0 [&_li]:border-t-0 [&_li]:border-solid [&_li]:border-b-base-20 [&_li]:py-3 [&_li]:text-[14px]  [&_li_a]:focus:outline-none">
          <Tabs />
        </ul>
      </div>
    </div>
  ) : null;
};

ResourcesSubNav.propTypes = {
  currentTabResources: propTypes.array.isRequired,
  isMobile: propTypes.bool,
  setHoverResources: propTypes.func,
};

export default ResourcesSubNav;
